var inAppConfigs = require("../../public/inAppConfigs");

const getInAppConfigs = configName => {
  return inAppConfigs[configName] || "";
};

export default getInAppConfigs;
